import i18n from '@/i18n';

const PageActions = () =>
  import(
    /* webpackChunkName: "actions" */ '@/pages/actionplan/actions/Actions.vue'
  );

const PageAction = () =>
  import(
    /* webpackChunkName: "action" */ '@/pages/actionplan/actions/Action.vue'
  );

export const ACTIONPLAN_ACTIONS_ITEM_ROUTE_NAME = 'actionplans-actions-item';
export const ACTIONPLAN_ACTIONS_LIST_ROUTE_NAME = 'actionplans-actions-list';

export default {
  getActionsRoute() {
    return {
      path: 'actions',
      name: ACTIONPLAN_ACTIONS_LIST_ROUTE_NAME,
      components: {
        default: PageActions,
      },
      meta: {
        authorizations: ['isMy360'],
        title: 'actions',
        icon: i18n.t('message.actions.icon'),
      },
    };
  },
  getActionRoute() {
    return {
      path: 'actions/:actionId',
      name: ACTIONPLAN_ACTIONS_ITEM_ROUTE_NAME,
      props: true,
      components: {
        default: PageAction,
      },
      meta: {
        isHidden: true,
        parent: 'actions',
      },
    };
  },
};
